import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ShowcaseReviewSummaryDto
*  Рейтинг карточки товара.
*/
export class ShowcaseReviewSummaryDto extends ActiveModel {

  /**
  * rating
  * Средняя оценка (1 знак) или `null`, если отзывов нет.  */
  @ActiveField()
  rating?: null | number


  /**
  * count
  * Число опубликованных отзывов.  */
  @ActiveField(0)
  count: number = 0


/**
  * distribution
  * Число отзывов по оценкам; элемент 0 — оценка 1.  */
  @ActiveField({
    setter(model: ShowcaseReviewSummaryDto, prop: string, value: Array<number>, receiver?: ShowcaseReviewSummaryDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => Number.parseInt(v)) : value,
        
        receiver)
    }
  })
  distribution: Array<number> = []
}
